import { LogLevelField } from "./LogLevelField";
import { MoreParameters } from "./MoreParameters";
import styles from "./parameterForms.module.css";
import { declaredDefault } from "./parameterValues";
import { SwitchParameter } from "./SwitchParameter";
import { TagOnSuccessField } from "./TextParameter";
import { TopicsControl } from "./TopicsControl";
import { type ParameterFormProps } from "./types";

const COVERED_KEYS = [
  "TOPICS",
  "CREATE_FLIGHT_EVENTS",
  "INGESTED_TAG",
  "LOG_LEVEL",
] as const;

/** The levels `ulog_ingestion`'s argument parser accepts. */
const LOG_LEVELS = ["DEBUG", "INFO", "WARNING", "ERROR", "CRITICAL"] as const;

/** `ulog_ingestion`: PX4 flight logs. */
export function UlogIngestionForm(props: ParameterFormProps) {
  const { name, action } = props;
  return (
    <div className={styles.form} data-testid="parameter-form-ulog_ingestion">
      <TopicsControl name={name} includeKey="TOPICS" />
      <SwitchParameter
        name={name}
        parameterKey="CREATE_FLIGHT_EVENTS"
        label="Detect flight events"
        description="GPS glitches, sensor clipping, and console log errors."
        defaultOn={
          (
            declaredDefault(action, "CREATE_FLIGHT_EVENTS", "True") ?? "True"
          ).toLowerCase() === "true"
        }
        spelling="title"
      />
      <TagOnSuccessField
        name={name}
        defaultTag={declaredDefault(action, "INGESTED_TAG", "ulg")}
      />
      <MoreParameters
        {...props}
        coveredKeys={COVERED_KEYS}
        disclosedKeys={["LOG_LEVEL"]}
      >
        <LogLevelField
          name={name}
          levels={LOG_LEVELS}
          defaultLevel={declaredDefault(action, "LOG_LEVEL", "INFO") ?? "INFO"}
        />
      </MoreParameters>
    </div>
  );
}
